/** An enumeration. */
export const MyOrderStatus = {
  DRAFT: "Draft",
  UNCONFIRMED: "Unconfirmed",
  UNFULFILLED: "Unfulfilled",
  PARTIALLY_FULFILLED: "Partially Fulfilled",
  PARTIALLY_RETURNED: "Partially Returned",
  RETURNED: "Returned",
  FULFILLED: "Fulfilled",
  CANCELED: "Canceled",
  EXPIRED: "Expired",
};

export const MyPaymentStatus = {
  CANCELED: "Canceled",
  FULLY_CHARGED: "Paid",
  FULLY_REFUNDED: "Fully Refunded",
  NOT_CHARGED: "Not Payed",
  PARTIALLY_CHARGED: "Partially Payed",
  PARTIALLY_REFUNDED: "Partially Refunded",
  PENDING: "Pending",
  REFUSED: "Refused",
};

export const MyOrderStatusColors = {
  FULFILLED: "#009CDE", //blue
  PAID: "#00E261", //green
  RETURNED: "#F79E1B", //orange
  FAILED: "#FF0000", //red
  UNFULFILLED: "#aaaaaa", //gray
  CANCELED: "#FF0000", //red
};

export const MyPaymentStatusColors = {
  CANCELED: "#FF0000",
  FULLY_CHARGED: "#00E261",
  FULLY_REFUNDED: "#00E261",
  NOT_CHARGED: "#aaaaaa",
  PARTIALLY_CHARGED: "#F79E1B",
  PARTIALLY_REFUNDED: "#F79E1B",
  PENDING: "#009CDE",
  REFUSED: "#FF0000",
};
